import { useReduxState } from 'hooks';
import { EmptyIndicator } from 'components/common';

import { EmptyIndicatorProps } from 'components/common/EmptyIndicator';

const PageEmptyIndicator = (props: EmptyIndicatorProps) => {
  const { theme } = useReduxState();

  return (
    <EmptyIndicator
      descriptionStyle={{ color: theme.pageTextColorLighter }}
      iconStyle={{
        backgroundColor: theme.pageIconBackgroundColor,
        color: theme.pageIconTextColorLighter
      }}
      titleStyle={{ color: theme.pageIconTextColorLighter }}
      {...props}
    />
  );
};

export default PageEmptyIndicator;
